import { render, staticRenderFns } from "./today.vue?vue&type=template&id=d54c922a"
import script from "./today.vue?vue&type=script&lang=js"
export * from "./today.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports